import { useNavigate } from 'react-router-dom'
import { Button } from '../ui/button'
import { ChevronLeft } from 'lucide-react'

type PageTitleProps = {
  title?: string
}

export const PageTitle = ({ title }: PageTitleProps) => {
  const navigate = useNavigate()

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="outline"
        size="icon"
        onClick={() => {
          navigate(-1)
        }}
        disabled={window.history.state.idx === 0}
      >
        <ChevronLeft />
      </Button>

      <h3>{title}</h3>
    </div>
  )
}
